import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GroupState } from '../../types/Spreadsheet';
import { RootState } from '../store';

interface GroupingState {
  groupBy: GroupState;
}

const initialState: GroupingState = {
  groupBy: null
};

const groupBySlice = createSlice({
  name: 'grouping',
  initialState,
  reducers: {
    setGroupBy( state, action: PayloadAction<GroupState> ) {
      state.groupBy = action.payload;
    },
    clearGroupBy( state ) {
      state.groupBy = null;
    }
  }
});

export const { setGroupBy, clearGroupBy } = groupBySlice.actions;
export const selectGroupBy = ( state: RootState ) => state.spreadsheet.groupBy.groupBy;
export default groupBySlice.reducer;